// Shared constants
export const APP_NAME = 'Resida';
export const APP_VERSION = '0.1.0';
// Brand strings - derived from APP_NAME so renaming only requires changing APP_NAME
export const EMAIL_FOOTER_PLATFORM_ADMIN = `${APP_NAME} Platform Administration`;
export const EMAIL_FOOTER_PAYMENT = `Payment processing by ${APP_NAME}`;
export const EMAIL_FOOTER_PROPERTY_MGMT = `${APP_NAME} Property Management`;
export const EMAIL_FOOTER_SIGNING = `Sent via ${APP_NAME}`;
export const EMAIL_WELCOME_GREETING = `Welcome to ${APP_NAME}!`;
export const EMAIL_REGISTRATION_SUBJECT = `Welcome to ${APP_NAME} - Complete Your Registration`;
export const EMAIL_REGISTRATION_PREVIEW = `Complete your ${APP_NAME} registration`;
// API Configuration
export const API_VERSION = 'v1';
export const API_TIMEOUT = 30000; // 30 seconds
// Pagination
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;
// Rate Limiting
export const RATE_LIMIT_WINDOW = 60 * 1000; // 1 minute
export const RATE_LIMIT_MAX_REQUESTS = 100;
// Message Limits
export const SMS_MAX_LENGTH = 1600; // SMS concatenation limit
export const EMAIL_MAX_LENGTH = 500000; // ~500KB
export const ATTACHMENT_MAX_SIZE = 25 * 1024 * 1024; // 25MB
// Queue Configuration
export const QUEUE_RETRY_ATTEMPTS = 3;
export const QUEUE_RETRY_DELAY = 5000; // 5 seconds
// LLM Configuration
export const LLM_MAX_TOKENS = 4096;
export const LLM_TEMPERATURE = 0.7;
export const EMBEDDING_DIMENSIONS = 1536; // OpenAI ada-002
// Cache TTL (Time to Live)
export const CACHE_TTL_SHORT = 60; // 1 minute
export const CACHE_TTL_MEDIUM = 300; // 5 minutes
export const CACHE_TTL_LONG = 3600; // 1 hour
// Error Codes
export const ERROR_CODES = {
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
    AUTHORIZATION_ERROR: 'AUTHORIZATION_ERROR',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    EXTERNAL_SERVICE_ERROR: 'EXTERNAL_SERVICE_ERROR',
};
// HTTP Status Codes
export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    TOO_MANY_REQUESTS: 429,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE: 503,
};
// Regex Patterns
export const PATTERNS = {
    PHONE: /^\+?[1-9]\d{1,14}$/,
    EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    UUID: /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
};
//# sourceMappingURL=constants.js.map